import { c as _c } from "react/compiler-runtime";
interface OtolaryngologyIconProps {
  size?: number;
  className?: string;
}
const OtolaryngologyIcon = t0 => {
  const $ = _c(7);
  const {
    size: t1,
    className: t2
  } = t0;
  const size = t1 === undefined ? 18 : t1;
  const className = t2 === undefined ? "" : t2;
  const t3 = `dynamic-size ${className}`;
  let t4;
  if ($[0] !== size) {
    t4 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = t4 as React.CSSProperties;
  let t6;
  let t7;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path d="M13.4333 24.9999C11.4713 24.9999 10.0887 23.4775 9.58599 22.5488C9.41492 22.2312 9.53362 21.8377 9.85481 21.6685C10.176 21.4994 10.574 21.6167 10.7451 21.9343C10.794 22.0206 11.988 24.1334 14.0757 23.619C16.0971 23.1219 16.5196 21.6064 16.5196 20.4257C16.5196 20.3084 16.5161 20.191 16.5091 20.0702C16.4672 19.069 16.4113 17.6985 18.5375 15.5029C20.5519 13.4247 21.1175 10.1658 19.8851 7.75621C19.4627 6.92768 17.0817 2.89208 11.7994 4.79423C7.53663 6.33736 8.35009 11.1014 8.385 11.3016C8.44785 11.6537 8.21393 11.992 7.85434 12.0576C7.49823 12.1232 7.15609 11.8885 7.08976 11.5364C7.07928 11.4777 6.03541 5.49503 11.3456 3.57906C16.2508 1.80809 19.6407 4.41104 21.0547 7.17279C22.5315 10.0588 21.8681 13.9425 19.4836 16.4039C17.745 18.1991 17.7834 19.1243 17.8183 20.0184C17.8253 20.1565 17.8288 20.2945 17.8288 20.4257C17.8288 21.5097 17.4936 24.1127 14.3899 24.8791C14.0583 24.9619 13.7371 24.9999 13.4298 24.9999H13.4333Z" fill="currentColor" />;
    t7 = <path d="M13.0806 19.9324C12.8328 19.9324 12.5849 19.8806 12.351 19.777C11.4014 19.3593 10.9475 18.2408 10.8986 18.1131C10.7695 17.7782 10.9405 17.4019 11.2792 17.2742C11.6178 17.1465 11.9984 17.3156 12.1275 17.647C12.2043 17.8404 12.5046 18.4203 12.8886 18.586C13.0213 18.6447 13.1505 18.6413 13.3111 18.5826C13.9604 18.3306 13.751 17.6263 13.6672 17.4088C13.4228 16.822 13.3425 15.4825 14.7634 14.5332C15.6048 13.9705 15.741 13.3249 15.2347 12.2962C15.1195 12.0614 14.7355 11.9751 14.4143 12.0165C14.1455 12.0476 13.8382 12.1822 13.7929 12.3963C13.6043 13.2766 13.0388 13.9152 12.351 14.0257C11.9425 14.0913 11.15 14.0153 10.4273 12.7898C9.78841 11.7024 9.73605 10.2283 10.2912 9.03039C10.8463 7.83593 11.9355 7.03502 13.3565 6.77266C14.9066 6.48958 16.3345 6.82444 17.3749 7.71856C18.3664 8.57125 18.9005 9.85201 18.8412 11.2294C18.8237 11.5885 18.5235 11.8681 18.1569 11.8508C17.7938 11.837 17.5145 11.5332 17.5285 11.1742C17.5704 10.1938 17.2003 9.29275 16.5125 8.69898C15.7829 8.07068 14.746 7.83938 13.5973 8.04997C12.33 8.28126 11.7505 9.00622 11.4886 9.57238C11.1116 10.3836 11.143 11.4124 11.5689 12.1339C11.8762 12.6586 12.1031 12.7415 12.1485 12.738C12.2183 12.7277 12.4243 12.5344 12.5116 12.1235C12.6687 11.3813 13.3565 10.8324 14.2607 10.722C15.2173 10.6046 16.0656 10.9981 16.4218 11.7231C17.4237 13.7564 16.4741 14.9578 15.5036 15.6068C14.5993 16.2109 14.8751 16.8841 14.8891 16.9117C14.9345 17.0257 15.2766 17.9301 14.9066 18.769C14.7041 19.2351 14.3165 19.5872 13.7929 19.7909C13.5589 19.8806 13.3215 19.9255 13.0876 19.9255L13.0806 19.9324Z" fill="currentColor" />;
    $[2] = t6;
    $[3] = t7;
  } else {
    t6 = $[2];
    t7 = $[3];
  }
  let t8;
  if ($[4] !== t3 || $[5] !== t5) {
    t8 = <svg className={t3} style={t5} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none">{t6}{t7}</svg>;
    $[4] = t3;
    $[5] = t5;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  return t8;
};
export default OtolaryngologyIcon;